module.exports = __webpack_public_path__ + "static/media/xlerateFinancial.9412c954.png";